module.exports = __webpack_public_path__ + "static/media/logo-design-3.ca499c40.png";